import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { ApiMissionsService } from '../../../../services/missions/api/api-missions.service';
import { AlertsService } from '../../../../services/alerts.service';
import { Mission } from '../../../../models/missions/mission.model';
import { MissionType } from '../../../../enums/missions/mission-type.enum';

@Component({
  selector: 'app-mission-edit-modal',
  templateUrl: './mission-edit-modal.component.html',
  standalone: true,
  imports: [ModalModule, CommonModule, FormsModule]
})
export class MissionEditModalComponent {

  @ViewChild('modal') modal!: ModalDirective;

  isLoading: boolean = false;
  missionId: number = 0;
  type: number = 0;
  startDate: string = '';
  endDate: string = '';
  completeQuantity: number = 0;
  pointsReward: number = 0;
  customParam: number = 0;

  readonly missionTypes = Object.entries(MissionType).filter(([, v]) => typeof v === 'number') as [string, number][];

  private callbackSaved?: () => void;

  constructor(private apiMissionsService: ApiMissionsService, private alertsService: AlertsService) {}

  show(mission: Mission, callbackSaved?: () => void): void {
    this.callbackSaved = callbackSaved;
    this.missionId = mission.missionId;
    this.type = mission.type;
    this.startDate = mission.startDateTimestamp ? this.timestampToDateString(mission.startDateTimestamp) : '';
    this.endDate = mission.endDateTimestamp ? this.timestampToDateString(mission.endDateTimestamp) : '';
    this.completeQuantity = mission.completeQuantity;
    this.pointsReward = mission.pointsReward;
    this.customParam = mission.customParam;
    this.isLoading = false;
    this.modal.show();
  }

  save(): void {
    this.isLoading = true;
    const startTimestamp = this.startDate ? Math.floor(new Date(this.startDate + 'Z').getTime() / 1000) : 0;
    const endTimestamp = this.endDate ? Math.floor(new Date(this.endDate + 'Z').getTime() / 1000) : 0;
    this.apiMissionsService.editMission(this.missionId, this.type, startTimestamp, endTimestamp, this.completeQuantity, this.pointsReward, this.customParam).then(
      () => {
        this.isLoading = false;
        this.modal.hide();
        this.alertsService.displayAlertSuccess('Mission updated !');
        if (this.callbackSaved) { this.callbackSaved(); }
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('Error updating mission : ' + error);
      }
    );
  }

  private timestampToDateString(timestamp: number): string {
    const d = new Date(timestamp * 1000);
    const month = (d.getUTCMonth() + 1).toString().padStart(2, '0');
    const day = d.getUTCDate().toString().padStart(2, '0');
    const hours = d.getUTCHours().toString().padStart(2, '0');
    const minutes = d.getUTCMinutes().toString().padStart(2, '0');
    return `${d.getUTCFullYear()}-${month}-${day}T${hours}:${minutes}`;
  }
}
